import { render } from "./summary.vue?vue&type=template&id=cf1fea84&scoped=true&ts=true"
import script from "./summary.vue?vue&type=script&lang=ts"
export * from "./summary.vue?vue&type=script&lang=ts"

import "./summary.vue?vue&type=style&index=0&id=cf1fea84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1fea84"]])

export default __exports__